import { bootstrapApplication } from '@angular/platform-browser';
import { fast } from 'ngx-fastboot';
import { AppComponent } from './app/app.component';

fast(bootstrapApplication, AppComponent, { providers: [() => import('./configs/angular.config')] }).catch((err) =>
  console.error(err)
);
